import React, { Component } from 'react'
import Select from 'react-select'
import ProjectOption from 'containers/scheduler/project-filter/project-option'
import { prop, sortBy } from 'ramda'

const ProjectValue = ({collection, filteredItems, collectionToFilter, icon, filterSelected, hidePlaceholer, svgIcon }) => {
  let placeholder = ''
  if(!hidePlaceholer) placeholder = `${collectionToFilter} (${ filterSelected? filteredItems : collection.length - filteredItems} of ${collection.length})`
  return <span className="place-holder">
  {!hidePlaceholer && !svgIcon && <i className={icon} />}
  {!hidePlaceholer && svgIcon && icon}
  {placeholder}
</span>
  

}

class ProjectFilter extends Component {
  
  renderProjectValue = () => {
    return <ProjectValue
      collection={this.props.collection}
      filteredItems={this.props.filteredItems.size}
      filterSelected = {this.props.filterSelected}
      collectionToFilter={this.props.collectionToFilter}
      icon={this.props.icon}
      hidePlaceholer={this.props.hidePlaceholer}
      svgIcon={this.props.svgIcon}
    />
  }

  renderOptionComponent = (props) =>
    <ProjectOption
      filteredItems={this.props.filteredItems}
      filterSelected = {this.props.filterSelected}
      {...props}
    />

  render () {
    return (
      <div className="project-filter">
        <Select
          onOpen={this.props.onOpen}
          closeOnSelect={false}
          removeSelected={false}
          searchable={this.props.searchable}
          clearable={false}
          options={sortBy(prop('label'), this.props.collection)}
          className="project-dropdown"
          optionComponent={this.renderOptionComponent}
          valueRenderer={this.renderProjectValue}
          onChange={this.props.onChange}
          onClose={this.props.onClose}
          value={this.props.filteredItems}
          placeholder={
            <span className="place-holder">
              <i className={this.props.icon} />
              {this.props.collectionToFilter}
              ({this.props.collection.length} of {this.props.collection.length})
            </span>
          }
        />
        { this.props.filterSelected?  (!this.props.filteredItems.size
            ? !this.props.selectAllDisabled? <a onClick={this.props.onSelectAll}>Select All</a> : <></>
            : <a onClick={this.props.onClearAll}>Clear All</a>
        ): ( this.props.filteredItems.size
          ? !this.props.selectAllDisabled? <a onClick={this.props.onSelectAll}>Select All</a> : <></>
          : <a onClick={this.props.onClearAll}>Clear All</a>
      )}
      </div>
    )
  }
}

export default ProjectFilter
